import { ActionButton, Spinner, SpinnerSize } from "@fluentui/react";
import { useEffect, useRef } from "react";
import { SocialAccountModel } from "../../models/SocialAccountModel";
import { useCustomerAccountVM } from "../../viewmodels/CustomerAccountVM";
import AccountEntryView from "./AccountEntryView";
import AccountGridView from "./AccountGridView";

export default function CustomerAccountView() {
    const hasLoaded = useRef(false);
    const vm = useCustomerAccountVM();

    useEffect(() => {
        if (hasLoaded.current) return;

        hasLoaded.current = true;

        vm.getList();
    }, [vm]);

    const onDelete = (account: SocialAccountModel) => {
        if (window.confirm(`Are you sure to delete social account ${account.name}?`)) {
            vm.del(account.id);
        }
    }

    const onClose = () => {
        vm.setIsEdit(false);
        vm.setShowEntry(false);
        vm.resetForm();
    }

    const onSubmit = () => {
        if (vm.isEdit) {
            vm.edit();
        } else {
            vm.create();
        }
    }

    const refreshButton = () => {
        return <>
            <ActionButton
                iconProps={{ iconName: "Refresh" }}
                onClick={vm.getList}
            >Refresh</ActionButton>
        </>;
    }

    const addButton = () => {
        return <>
            <ActionButton
                iconProps={{ iconName: "Add" }}
                onClick={() => vm.setShowEntry(true)}
            >Add New</ActionButton>
        </>;
    }

    const headerView = () => {
        return <div className="ph-15 pv-10 container">
            <div className="font-title pr-10" style={{ marginBottom: 4 }}>Social Accounts</div>
            {addButton()}
        </div>;
    }

    const mainContent = () => {
        return <div className="ms-Grid">
            <div className="ms-Grid-row center">
                {headerView()}
            </div>

            <div>
                {vm.loading && <Spinner size={SpinnerSize.large} />}

                <AccountGridView
                    accounts={vm.accounts}
                    key={vm.listHash}
                    onEdit={(account: SocialAccountModel) => {
                        vm.setForm(account);
                        vm.setIsEdit(true);
                        vm.setShowEntry(true);
                    }}
                    onDelete={onDelete}
                />
            </div>
        </div>;
    }

    return <>
        {mainContent()}

        {vm.showEntry && <>
            <AccountEntryView
                isEdit={vm.isEdit}
                form={vm.form}
                errorMessages={vm.errorMessages}
                submitting={vm.submitting}
                onValueChange={vm.setField}
                onSubmit={onSubmit}
                onClose={onClose}
            />
        </>}
    </>;
}